import { Commodity } from "@/pages/sy/models/Commodity";
import { useState } from "react";

export const useChargeColorsAndWeights = () => {
  const [bucketCapacity, setBucketCapacity] = useState<number>(0);
  const [uiCapacity, setUiCapacity] = useState<number>(0);

  const getCommodityColor = (commodityId: number, commodities: Commodity[]) => {
    const commodity = commodities.find((c) => c.CommodityId === commodityId);
    return commodity?.CommodityColor || "#888888";
  };

  const getRecipeLayerPercentage = (
    layerWeight: number,
    recipeTotalWeight: number,
  ) => {
    if (!recipeTotalWeight || recipeTotalWeight === 0) return 0;
    return Math.round((layerWeight / recipeTotalWeight) * 10000) / 100;
  };

  const getBgColorWithAlpha = (color: string, alpha = 0.15) => {
    if (color?.startsWith("#")) {
      const r = parseInt(color.slice(1, 3), 16);
      const g = parseInt(color.slice(3, 5), 16);
      const b = parseInt(color.slice(5, 7), 16);
      return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    } else if (color?.startsWith("rgb(")) {
      return color.replace("rgb(", "rgba(").replace(")", `, ${alpha})`);
    }
    return `rgba(136, 136, 136, ${alpha})`;
  };

  return {
    bucketCapacity,
    setBucketCapacity,
    uiCapacity,
    setUiCapacity,
    getCommodityColor,
    getRecipeLayerPercentage,
    getBgColorWithAlpha,
  };
};
